import { useEffect, useState } from "react";

function useFetch(endpoint, initial=null) {
  const [data, setData] = useState(initial);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch("/api/wp/v2" + endpoint);
      const json = await response.json();
      setData(json);
      setLoading(false);
    }
    fetchData();
  }, [endpoint]);

  return [data, loading];
}

export default useFetch;
